module.exports = {"resolutionCenter":"/signin/?returnUri={originURL}%2Fcgi-bin%2Fwebscr%3Fcmd%3D_complaint-view"}